import app from "@/app";
import http from "@/http";
import { ExpandableApi, ExpandableController } from "./expandable-controller";

export { Expandable, type ExpandableDelegate, type ExpandableSettings } from "./expandable";

class ExpandableControllerImpl extends ExpandableController implements ExpandableApi {

	protected createApi(): ExpandableApi {
		return this;
	}
	
	getContent(data: FormData, loadingElement: HTMLElement): Promise<string> {
		const request = http.post(data);
		const withToast = http.withToastOnError(request, "Failed to load content");
		return http.withSpinner(withToast, loadingElement, 500).then(http.asText);
	}
}

app.register("expandable", ExpandableControllerImpl);
